import {useContext, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {Context} from "../index";
import {observer} from "mobx-react-lite";

const Auth = () => {
    const location = useLocation();
    const isLogin = location.pathname === "/login";

    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const [isRegistered, setIsRegistered] = useState("");
    const [isClosed, setIsClosed] = useState(true);
    const [process, setProcess] = useState(false);

    const {userStore} = useContext(Context)

    const handleSubmit = async (e) => {
        if (!process) {
            setProcess(true);
            e.preventDefault();
            try {
                if (isLogin) {
                    await userStore.login(email, password);
                    navigate("/");
                    if (!userStore.user.isActivated) throw "Аккаунт не активирован"
                } else {
                    await userStore.register(email, name, password);
                    setIsRegistered("true");
                }
            } catch (err) {
                alert(`ОКАК: ${err?.response?.data?.message || err}`);
            } finally {
                setProcess(false);
            }
        }
    };

    async function forgotPassword() {
        if (!process) {
            setProcess(true);
            try {
                await userStore.forgotPassword(email);
                setIsRegistered("forgotPassword");
            } catch (e) {
                alert(`ОКАК: ${e?.response?.data?.message || e}`);
            } finally {
                setProcess(false);
            }
        }
    }

    return (
        <div className="container">
            <div className="block-auth">
                {isRegistered === "" ?
                    <form id="auth" onSubmit={handleSubmit}>
                        <p id={`h-${isLogin ? "log" : "reg"}`}>{isLogin ? "Вход" : "Регистрация"}</p>
                        <div className="input-cont"><input required type="email" maxLength="254" placeholder="Введите email" onChange={(e) => setEmail(e.target.value)} value={email}/><i className="icon-email"></i></div>
                        {!isLogin ? <div className="input-cont"><input required type="text" maxLength="25" placeholder="Введите ник" value={name} onChange={(e) => setName(e.target.value)}/><i className="icon-user"></i></div> : null}
                        <div className="input-cont"><input required type={isClosed ? "password" : "text"} minLength="3" maxLength="32" placeholder={`${isLogin ? "Введите" : "Придумайте"} пароль`} value={password} onChange={(e) => setPassword(e.target.value)}/><i className={!isClosed ? "icon-eye" : "icon-eyeoff"} onClick={() => setIsClosed(prev => !prev)}></i>{isLogin && <div id="forgot-pass" style={{cursor: "pointer"}} onClick={() => forgotPassword()}>Забыли пароль?</div>}</div>
                        <button id={`b-${isLogin ? "log" : "reg"}`} type="submit">{isLogin ? "Войти" : "Зарегистрироваться"}</button>
                        <p>{!isLogin ? <>Есть аккаунт? <a href="/login">Войдите</a></> : <>Нет аккаунта? <a href="/register">Зарегистрируйтесь</a></>}</p>
                    </form>
                    :
                    <p style={{fontSize: "20px", padding: "10px"}}>На адрес <span style={{fontFamily: "Source_Sans3_bold, sans-serif"}}>{email}</span> отправлено письмо с ссылкой на {isRegistered === "true" ? "активацию аккаунта, активируйте аккаунт для доступа к функционалу" : "восстановление пароля, восстановите пароль и войдите в аккаунт снова"}<br/> <span style={{fontSize: "16px"}}>Если нет письма, проверьте папку "Спам"</span></p>
                }
            </div>
        </div>
    );
};

export default observer(Auth);